// Cloudflare Pages Functions client (/api/*). 4-level model:
// title → creative(대분류) → file(소분류, owns base in R2, key = file id) → canvas.

const BASE = '/api';

// Full library tree: titles[].creatives[].files[].canvases[] (pkg/tw parsed).
export async function fetchLibrary() {
  const res = await fetch(`${BASE}/titles`);
  if (!res.ok) throw new Error(`GET /titles ${res.status}`);
  return res.json();
}

export function createTitle({ id, name }) {
  return jsonPost(`${BASE}/titles`, { id, name });
}
export function createCreative({ id, titleId, name }) {
  return jsonPost(`${BASE}/creatives`, { id, title_id: titleId, name });
}

export function updateTitle(id, patch)    { return jsonPatch(`${BASE}/titles/${id}`, patch); }
export function deleteTitle(id)           { return del(`${BASE}/titles/${id}`); }
export function updateCreative(id, patch) { return jsonPatch(`${BASE}/creatives/${id}`, patch); }
export function deleteCreative(id)        { return del(`${BASE}/creatives/${id}`); }

// File (소분류) — owns the base HTML; source uploaded to R2 (key = file id).
export async function createFile({ id, creativeId, name, baseFileName, source }) {
  const fd = new FormData();
  fd.append('id', id);
  fd.append('creative_id', creativeId);
  fd.append('name', name);
  if (baseFileName) fd.append('base_file_name', baseFileName);
  fd.append('source', new Blob([source || ''], { type: 'text/html' }), id);
  const res = await fetch(`${BASE}/files`, { method: 'POST', body: fd });
  if (!res.ok) throw new Error(`POST /files ${res.status}`);
  return res.json();
}
export function updateFile(id, patch) { return jsonPatch(`${BASE}/files/${id}`, patch); }
export function deleteFile(id)        { return del(`${BASE}/files/${id}`); }

// Replace a file's base build (R2 object) + optionally name/base_file_name.
export async function replaceFileBase({ id, name, baseFileName, source }) {
  const fd = new FormData();
  if (name) fd.append('name', name);
  if (baseFileName) fd.append('base_file_name', baseFileName);
  fd.append('source', new Blob([source || ''], { type: 'text/html' }), id);
  const res = await fetch(`${BASE}/files/${id}`, { method: 'PUT', body: fd });
  if (!res.ok && res.status !== 204) throw new Error(`PUT /files/${id} ${res.status}`);
}

// Canvas = metadata + overrides only (base HTML belongs to the file).
export function createCanvas({ id, fileId, name, pkg, tw }) {
  return jsonPost(`${BASE}/canvases`, { id, fileId, name, pkg: pkg || {}, tw: tw || [] });
}
export function updateCanvas(id, patch) { return jsonPatch(`${BASE}/canvases/${id}`, patch); }
export function deleteCanvasApi(id)     { return del(`${BASE}/canvases/${id}`); }

// Base HTML for a file (R2 object key = file id).
export async function fetchFileSource(fileId) {
  const res = await fetch(`${BASE}/assets/${encodeURIComponent(fileId)}`);
  if (!res.ok) throw new Error(`GET /assets/${fileId} ${res.status}`);
  return res.text();
}

export function assetUrl(key) { return `${BASE}/assets/${key}`; }

async function jsonPost(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`POST ${url} ${res.status}`);
  return res.json();
}

async function jsonPatch(url, body) {
  const res = await fetch(url, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok && res.status !== 204) throw new Error(`PATCH ${url} ${res.status}`);
}

async function del(url) {
  const res = await fetch(url, { method: 'DELETE' });
  if (!res.ok && res.status !== 204) throw new Error(`DELETE ${url} ${res.status}`);
}
